import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import PublicLayout from "../../components/public/Layout/layout";
import Header from "../../components/student/Header/index";
import Categories from "../../containers/student/home/categories";
import DownloadAppComp from "../../containers/student/home/downloadAppComp";
import RecordesComp from "../../containers/student/home/recordes";
import Teachers from "../../containers/student/home/teachers";
import { getAllTeachersRequest } from "../../modules/public/publicData/Actions";
import { getUserDataRequest } from "../../modules/user/Actions";

const Home = () => {
  const dispatch = useDispatch();
  const token = window.localStorage.getItem("token");
  const userData = useSelector((state) => state.user.userData);
  const [selectedDepartment, setSelectedDepartment] = useState(null);

  const handleSelectDepartment = (department) => {
    setSelectedDepartment(department);
    const teachersSection = document.getElementById("teachers-section");
    if (teachersSection) {
      teachersSection.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  useEffect(() => {
    if (token) {
      dispatch(getUserDataRequest());
    }
  }, [token]);

  useEffect(() => {
    dispatch(getAllTeachersRequest());
  }, []);

  return (
    <PublicLayout
      color="white"
      bg="main_1"
      register={userData?.id ? false : true}
    >
      <Header />
      <Categories
        selectedDepartment={selectedDepartment}
        onSelectDepartment={handleSelectDepartment}
      />
      <Teachers selectedDepartment={selectedDepartment} />
      {/* <RegisterComp /> */}
      <RecordesComp />
      {/* <SummeryComp /> */}
      {/* <StudentComp /> */}
      {/* <ReviewsComp /> */}
      <DownloadAppComp />
      {/* <AboutUs />
      <ContsctUs />
      <News /> */}
    </PublicLayout>
  );
};

export default Home;
